module.exports = __webpack_public_path__ + "static/fund-graph-56f55dbd4ca723e03ba3c4addd2bfa02.png";